import { l } from '../lib/imports'

export interface INeedSettings {
  thirstRate: number
  hungerRate: number
  energyRate: number
  toiletRate: number
  oxygenRate: number
  suitOxygenRate: number
  healthRate: number
}

export const defaultNeeds: INeedSettings = {
  thirstRate: 0.5,
  hungerRate: 0.25,
  energyRate: 0.25,
  toiletRate: 0.5,
  oxygenRate: 1,
  suitOxygenRate: 0.5,
  healthRate: 0.5,
}

export const nullNeeds: INeedSettings = {
  thirstRate: 0,
  hungerRate: 0,
  energyRate: 0,
  toiletRate: 0,
  oxygenRate: 0,
  suitOxygenRate: 0,
  healthRate: 0,
}

let needs: INeedSettings = l.cloneDeep(defaultNeeds)

export function getNeeds() {
  return needs
}

export function setNeeds(changes: Partial<INeedSettings>) {
  l.merge(needs, changes)
}
export function setNeedsNull() {
  setNeeds(nullNeeds)
}
